export const STORAGE_KEY = 'uctenky:settings:v1';

export const emptyRow = { description: "", vatRate: "", totalPrice: "" };

const defaultRowsData = Array.from({ length: 5 }, () => ({ ...emptyRow }));

export const defaultSettings = {
  sellerName: "",
  ico: "",
  dic: "",
  address: "",
  saleDate: "",
  rowCount: 3,
  receiptCount: 4,
  columnsCount: 2,
  scale: 1,
  showBorders: false,
  showCuttingLines: true,
  rowsData: defaultRowsData
};

const toNumber = (value, fallback) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export const normalizeRow = (row = {}) => ({
  description: row.description || "",
  vatRate: row.vatRate || "",
  totalPrice: row.totalPrice || ""
});

export const formatVatRate = (vatRate) => {
  const trimmedVatRate = String(vatRate || "").trim();

  if (!trimmedVatRate) return "";

  return trimmedVatRate.endsWith("%") ? trimmedVatRate : `${trimmedVatRate}%`;
};

export const createEmptyRow = () => ({ ...emptyRow });

export const ensureRowsLength = (rows, minLength) => {
  const normalizedRows = rows.map(normalizeRow);

  while (normalizedRows.length < minLength) {
    normalizedRows.push(createEmptyRow());
  }

  return normalizedRows;
};

export const loadSettings = () => {
  if (typeof window === 'undefined') return defaultSettings;

  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (!saved) return defaultSettings;

    const parsed = JSON.parse(saved);
    const rowCount = toNumber(parsed.rowCount, defaultSettings.rowCount);
    const rowsData = Array.isArray(parsed.rowsData) && parsed.rowsData.length
      ? ensureRowsLength(parsed.rowsData, rowCount)
      : ensureRowsLength(defaultRowsData, rowCount);

    return {
      ...defaultSettings,
      ...parsed,
      rowCount,
      receiptCount: toNumber(parsed.receiptCount, defaultSettings.receiptCount),
      columnsCount: toNumber(parsed.columnsCount, defaultSettings.columnsCount),
      scale: toNumber(parsed.scale, defaultSettings.scale),
      showBorders: Boolean(parsed.showBorders),
      showCuttingLines: parsed.showCuttingLines ?? defaultSettings.showCuttingLines,
      rowsData
    };
  } catch {
    return defaultSettings;
  }
};
